import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { ICellRendererParams } from 'ag-grid-community';
import { Button, InputGroup } from '@blueprintjs/core';
import { TranslatedMessage } from '../common/translation';
import { UserStore } from '../../store/UserStore';
import { AuthenticationStore, SecretariatStore, PharmacyStore } from '../../store';
import { Link } from 'react-router-dom';
import { ActionCode, Page, TLCode } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import { ApplicationStore } from '../../store';
import styled from '@emotion/styled';
import MainSectionLayout from '../layout/MainSectionLayout';
import {
  Column,
  ColumnChooser,
  DataGrid,
  Button as DGButton,
  DataGridTypes,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  Grouping,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  Sorting,
} from 'devextreme-react/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import DataSource from 'devextreme/data/data_source';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { boolean } from 'mobx-state-tree/dist/internal';

const ContainerCol = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const DivLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  margin-right: 5%;
  padding-bottom: 5px;
`;
const DivRight = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 5px;
  .bp3-icon {
    margin-right: 3px;
  }
`;

interface UserListPageProps extends WithTranslateProps {
  UserStore?: Instance<typeof UserStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
}

interface UserListPageState {
  isLoading: boolean;
}

@inject('UserStore', 'ApplicationStore', 'AuthenticationStore', 'SecretariatStore', 'PharmacyStore')
@observer
class UserListPage extends React.Component<UserListPageProps & WithTranslateProps, UserListPageState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
    const { UserStore } = this.props;
    this._isMounted && this.setState({ isLoading: true });
    if (UserStore!.dataList.length == 0 || UserStore!.dataList[0].roles.length == 0) {
      await UserStore!.getWithRole();
    }
    this._isMounted && this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  showUser = (user: any) => {
    return (
      (this.props.AuthenticationStore!.isSuperAdmin && this.props.SecretariatStore!.selectedSecretariatId === 0) ||
      (this.props.AuthenticationStore!.isSuperAdmin &&
        user !== undefined &&
        this.props.SecretariatStore!.selectedSecretariatId !== undefined &&
        this.props.SecretariatStore!.selectedSecretariatId === user!.secretaryId) ||
      (user !== undefined &&
        this.props.AuthenticationStore!.isSecretariat &&
        this.props.AuthenticationStore!.secretariatId === user!.secretaryId) ||
      (this.props.AuthenticationStore!.isAdmin &&
        !user.roles.find((r) => r.name === ActionCode.ADMIN_CODE || r.name === ActionCode.SUPER_ADMIN_CODE))
    );
  };

  buildGridData = () => {
    const data = this.props
      .UserStore!.dataList.filter((u) => this.showUser(u))
      .map((user) => {
        return {
          id: user.userId,
          firstName: user.firstName,
          lastName: user.lastName,
          userName: user.userName,
          email: user.email,
          roles: user.roles,
          status: user.isActive,
        };
      });

    return new DataSource({
      store: { type: 'array', key: 'id', data: data },
      langParams: {
        locale: 'fr',
        collatorOptions: {
          sensitivity: 'base',
        },
      },
    });
  };

  private onRowDoubleClicked = (ev) => {
    this.props.ApplicationStore!.navigate(`${Page.UserPage}/${ev.data.id}`);
  };

  onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          'Users.xlsx',
        );
      });
    });
  };

  goToPharmacy = (e) => {
    const ph = this.props.PharmacyStore!.dataList.filter((ph) => ph.apbNumber === parseInt(e.row.data.userName))[0];
    if (ph === undefined) return;
    const pharmacyId = ph.pharmacyId;
    this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${pharmacyId}`);
  }

  actionRenderer = (data: any) => {
    const isPharmacyUser = data.data.roles.some(role => role.name === "PharmacyUser");
    return <>
      <DGButton
        hint='suggestion'
        text='test'
      />
     {/* <Button
      text={this.props.translate(TLCode.USER_Goto_Pharmacy)}
      disabled={!isPharmacyUser}></Button> */}
      </>
  }

  
//   <>TEST
//   <DGButton
//   hint={translate(TLCode.GENERAL_Edit)}
//   icon={'user'}
//   onClick={(e) => {
//     this.props.ApplicationStore!.navigate(`${Page.UserPage}/${e.row!.data.id}`)
//     }}
//   />
//  &nbsp;
//  <DGButton
//    hint={translate(TLCode.USER_Goto_Pharmacy)}
//    icon={'home'}
//    onClick={this.goToPharmacy}
//    disabled={!data.data.roles.some(role => role.name === "PharmacyUser")}
//  />
// </>;



  public render() {
    const { translate } = this.props;

    return (
      <MainSectionLayout isLoading={this.state.isLoading} title={TLCode.USERS_Title}>
        <ContainerCol>
          <DivLine>
            <DivLeft />
            <DivRight>
              <Link to={Page.UserPage + '/-1'}>
                <Button intent="primary">
                  <TranslatedMessage id={TLCode.Add} />
                </Button>
              </Link>
            </DivRight>
          </DivLine>
          <DataGrid
            id="usersList"
            dataSource={this.buildGridData()}
            onRowDblClick={this.onRowDoubleClicked}
            onExporting={this.onExporting}
            showBorders
            allowColumnResizing
            width={'100%'}
            rowAlternationEnabled={true}
          >
            {/* <GroupPanel visible={true} />
            <Grouping autoExpandAll={false} />
            <ColumnChooser enabled={true} /> */}
            <Export enabled={true} texts={{ exportAll: translate(TLCode.GRID_EXCEL_EXPORT) }} />
            <Sorting mode="multiple" />
            <FilterPanel visible={true} />
            <HeaderFilter visible={true} />
            <FilterRow visible={true} applyFilter={'auto'} />
            <SearchPanel visible={true} highlightCaseSensitive={true} width={400} />
            <Column
              dataType="string"
              dataField="userName"
              caption={translate(TLCode.Username)}
              width={200}
              defaultSortOrder="asc"
              sortIndex={1}
            />
            <Column
              dataType="string"
              dataField="lastName"
              caption={translate(TLCode.Lastname)}
              width={200}
            />
            <Column
              dataType="string"
              dataField="firstName"
              caption={translate(TLCode.Firstname)}
              width={200}
            />
            <Column dataType="string" dataField="email" caption={translate(TLCode.Email)} width={200} />
            <Column dataType="boolean" dataField="status" caption={translate(TLCode.IS_ACTIVE)} width={80} />
            <Column
              dataType="string"
              dataField="roles"
              caption={translate(TLCode.Roles)}
              width={200}
              calculateDisplayValue={(r) => r.roles.map((r) => r.name).toString()}
              calculateCellValue={(r) => r.roles.map((r) => r.name).toString()}
            />
            <Column
              caption="Actions"
              type="buttons">
                <DGButton
                hint={translate(TLCode.GENERAL_Edit)}
                icon={'user'}
                onClick={(e) => {
                  this.props.ApplicationStore!.navigate(`${Page.UserPage}/${e.row!.data.id}`)
                  }}
                />
                &nbsp;
                <DGButton
                  hint={translate(TLCode.USER_Goto_Pharmacy)}
                  icon={'home'}
                  onClick={this.goToPharmacy}
                  visible={(e) => {
                    return e.row.data.roles.some(role => role.name === "PharmacyUser");
                  }}
                />
            </Column>
            <Pager
              visible={true}
              allowedPageSizes={[10, 20, 50]}
              showPageSizeSelector={true}
              showInfo={true}
              showNavigationButtons={true}
            />
            <Paging defaultPageSize={20} />
          </DataGrid>
        </ContainerCol>
      </MainSectionLayout>
    );
  }
}

export default withTranslate(UserListPage);
